










































import { Component, Mixins, Vue, Prop, Watch } from 'vue-property-decorator'
import SummaryResultApis from '@/mixins/requests/branch/SummaryResultApis.vue'
import { SubjectSummaryData } from '@/models/api/common/SummaryResultTypes.vue'
import SelectBase, { SelectOption } from '@/components/common/atoms/SelectBase.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import 'katex/dist/katex.min.css'
import katex from 'katex'

@Component({
  components: {
    SelectBase,
    ButtonBase,
  },
})
export default class SubjectSummary extends Mixins(SummaryResultApis) {
  @Prop()
  studyContentId!: string
  @Prop()
  store!: { selectedSubject: string; subjectSummaryData: SubjectSummaryData[] }
  @Prop({ default: false })
  isStudyModeRecommend!: boolean

  private selectedSubject = ''
  private activeTab = 1

  private summaryData: SubjectSummaryData[] | null = null

  private displaySummary: SubjectSummaryData | null = null

  private selectedSubjectCode: string | null = null

  @Watch('summaryData')
  private onChangeSummaryData() {
    if (this.summaryData) {
      this.store.subjectSummaryData = this.summaryData
    }
  }

  @Watch('selectedSubjectCode')
  private onChangeSelectedSubjectCode() {
    if (this.summaryData) {
      this.store.selectedSubject = this.selectedSubject
    }
  }
  private get subjectOptions(): SelectOption[] {
    if (!this.summaryData) return []
    return this.summaryData
      .filter((summaryData: SubjectSummaryData) => {
        return summaryData.correctRates.length !== 0
      })
      .map((summaryData: SubjectSummaryData) => {
        return { value: summaryData.subjectCode, text: summaryData.subjectName }
      })
  }

  private get showButtonColor(): string {
    return this.selectedSubject ? '' : 'pointer-events-none'
  }

  /**
   * 設問ラベル表示処理
   */
  private displayQuestionLabel(sortNum: number, labelText: string): string {
    const label = labelText ? labelText : `(${sortNum})`
    return label === process.env.VUE_APP_EMPTY_QUESTION_LABEL_WORD ? '' : label
  }

  private showSummary() {
    let targetSummary = null
    if (this.summaryData) {
      targetSummary = this.summaryData.find((summary: SubjectSummaryData) => {
        return summary.subjectCode === this.selectedSubject
      })
    }
    if (targetSummary) {
      this.selectedSubjectCode = this.selectedSubject
      this.displaySummary = targetSummary
    }
  }

  private async mounted() {
    if (this.store.subjectSummaryData) {
      this.summaryData = this.store.subjectSummaryData
    } else {
      Vue.prototype.$loading.start()
      try {
        this.summaryData = await this.getSubjectSummary(this.studyContentId)
      } catch (e) {
        if (e.response.data.status === 400) {
          alert(e.response.data.message.message)
        } else {
          alert('エラーが発生しました')
        }
      } finally {
        Vue.prototype.$loading.complete()
      }
    }
    if (this.store.selectedSubject) {
      this.selectedSubject = this.store.selectedSubject
      this.showSummary()
    }
  }
  private convertValue(value: number): string {
    return value !== null ? value.toFixed(1) : '—'
  }

  private get covertLatexAnswer(): any {
    return function (isLatex: boolean, answer: string) {
      return isLatex ? katex.renderToString(answer) : answer
    }
  }
}
